import ListStore from '@/store/core/ListStore';
import { action, computed, override } from 'mobx';
import services from '@/api/services';
import { Taxes } from '@/store/types';
import { dateFormat, numGroup } from '@/utils/filters';

export default class TaxpayerTaxDetailsStore extends ListStore<Taxes> {
  @override filters = {
    id: '',
    year: '',
  };

  sortColumns: (keyof Taxes)[] = [];

  @computed get processedData() {
    if (!this.data) return;
    return {
      items: this.data.taxes.map((tax) => ({
        ...tax,
        accrualDate: dateFormat(tax.accrualDate, {
          format: 'DD.MM.YYYY',
          addHours: 0,
        }),
        paymentDate: dateFormat(tax.paymentDate, {
          format: 'DD.MM.YYYY',
          addHours: 0,
        }),
        sumIncome: numGroup(tax.sumIncome),
        sumTax: numGroup(tax.sumTax),
      })),
      totalSumIncome: numGroup(this.data.totalSumIncome),
      totalSumTax: numGroup(this.data.totalSumTax),
    };
  }

  @action.bound async fetch() {
    this.isFetching = true;
    try {
      const { data } = await services.selfEmployee.getTaxDetails(
        this.filters.id,
        this.filters.year,
      );
      this.data = data;
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }
}
